import { styled } from 'styled-components';

export const PrintContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    vertical-align: bottom;
    grid-column-gap: 16px;
`;

export const PrintButtonContainer = styled.div`
    align-content: end;
    > button {
        text-transform: uppercase;
    }
`;

export const PrintOptionContainer = styled.div`
    width: 145px;
    display: flex;
    align-self: flex-end;
`;

export const SelectPrintLabel = styled.label``;
